(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("query-map-elevation", [], factory);
	else if(typeof exports === 'object')
		exports["query-map-elevation"] = factory();
	else
		root["query-map-elevation"] = factory();
})(self, function() {
return 